import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((_theme) => ({
  bg: {
    background: '#1e1e1e',
    color: 'white',
    '& p': {
      color: 'white',
    },
  },
  buttons: {
    '& button': {
      fontWeight: 600,
      color: _theme.palette.primary.main,
    },
  },
}));
